<template>
  <section class="figma-plugin">
    <div class="container">
      <div class="figma-plugin__content">
        <div class="figma-plugin__text">
          <p class="figma-plugin__eyebrow">
            Figma plugin
          </p>
          <h2 class="figma-plugin__title">
            Use Site Palette directly in Figma
          </h2>
          <p class="figma-plugin__subtitle">
            Install the Site Palette plugin from Figma Community to keep your color workflow close to your design files and move from inspiration to palette faster.
          </p>
          <ul class="figma-plugin__list">
            <li class="figma-plugin__list-item">
              Quick access from your Figma workspace
            </li>
            <li class="figma-plugin__list-item">
              A familiar Site Palette workflow for designers
            </li>
            <li class="figma-plugin__list-item">
              One click to open the plugin page and install it
            </li>
          </ul>
          <a
            class="figma-plugin__button"
            href="https://www.figma.com/community/plugin/1631159048065020915/site-palette"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img class="figma-plugin__button-icon" :src="iconFigma" alt="Figma icon" />
            Add to Figma
          </a>
        </div>
        <div class="figma-plugin__card">
          <ul class="figma-plugin__stack">
            <li
              v-for="palette in palettes"
              :key="palette.name"
              class="figma-plugin__palette"
            >
              <span class="figma-plugin__palette-name">{{ palette.name }}</span>
              <span class="figma-plugin__swatches">
                <span
                  v-for="(color, index) in palette.colors"
                  :key="index"
                  class="figma-plugin__swatch"
                  :style="{ background: color }"
                ></span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import iconFigma from '@/images/icon-figma.svg'

export default {
  data() {
    return {
      iconFigma,
      palettes: [
        { name: 'stripe.com', colors: ['#635BFF', '#0A2540', '#00D4FF', '#425466', '#F6F9FC'] },
        { name: 'linear.app', colors: ['#5E6AD2', '#1C1C1F', '#E1E2E6', '#8A8F98', '#F4F5F8'] },
        { name: 'vercel.com', colors: ['#000000', '#0070F3', '#7928CA', '#FF0080', '#EAEAEA'] }
      ]
    }
  }
};
</script>

<style scoped>
.figma-plugin {
  padding: 120px 20px 0 20px;
  background: #fff;
}

.container {
  width: 100%;
  max-width: 1224px;
  margin: 0 auto;
}

.figma-plugin__content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
  padding: 56px;
  background: linear-gradient(180deg, #f5f8fa 0%, #eef3ff 100%);
  border: 1px solid rgba(48, 128, 242, 0.12);
  border-radius: 24px;
}

.figma-plugin__text {
  max-width: 560px;
}

.figma-plugin__eyebrow {
  margin: 0 0 16px;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #3080F2;
}

.figma-plugin__title {
  margin: 0 0 20px;
  font-weight: 600;
  font-size: 44px;
  line-height: 50px;
  letter-spacing: -0.02em;
  color: #17191D;
}

.figma-plugin__subtitle {
  margin: 0 0 24px;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  color: #17191D;
}

.figma-plugin__list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin: 0 0 32px;
  padding: 0;
}

.figma-plugin__list-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #3D3D3D;
}

.figma-plugin__list-item::before {
  content: "";
  flex: none;
  width: 10px;
  height: 10px;
  /* center the dot on the first line: (line-height - dot) / 2 */
  margin-top: 7px;
  border-radius: 50%;
  background: #6159F7;
  box-shadow: 0 0 0 6px rgba(97, 89, 247, 0.12);
}

.figma-plugin__button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  min-height: 56px;
  padding: 14px 24px;
  background: #6159F7;
  border-radius: 10px;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: #FFFFFF;
}

.figma-plugin__button-icon {
  width: 24px;
  height: 24px;
  display: block;
}

.figma-plugin__button:hover {
  opacity: 0.8;
}

.figma-plugin__card {
  width: 360px;
  min-width: 360px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.figma-plugin__stack {
  margin: 0;
  padding: 10px 0;
  list-style: none;
}

.figma-plugin__palette {
  position: relative;
  margin-bottom: -6px;
  padding: 16px 18px;
  border-radius: 14px;
  background: #FFFFFF;
  box-shadow: 0 14px 34px rgba(23, 25, 29, 0.10);
}

.figma-plugin__palette:nth-child(1) {
  z-index: 3;
  transform: rotate(-2deg);
}

.figma-plugin__palette:nth-child(2) {
  z-index: 2;
  margin-left: 18px;
  transform: rotate(1.2deg);
}

.figma-plugin__palette:nth-child(3) {
  z-index: 1;
  margin-left: 6px;
  transform: rotate(-0.8deg);
}

.figma-plugin__palette-name {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  color: #17191D;
}

.figma-plugin__swatches {
  display: flex;
  gap: 6px;
}

.figma-plugin__swatch {
  flex: 1;
  height: 30px;
  border-radius: 7px;
  box-shadow: inset 0 0 0 1px rgba(23, 25, 29, 0.06);
}

@media screen and (max-width: 960px) {
  .figma-plugin__content {
    flex-direction: column;
  }

  .figma-plugin__text {
    max-width: 100%;
  }

  .figma-plugin__card {
    width: 100%;
    min-width: 0;
  }
}

@media screen and (max-width: 600px) {
  .figma-plugin {
    padding: 50px 16px 0 16px;
  }

  .figma-plugin__content {
    gap: 32px;
    padding: 32px 24px;
    border-radius: 20px;
  }

  .figma-plugin__title {
    font-size: 36px;
    line-height: 44px;
  }

  .figma-plugin__subtitle {
    font-size: 16px;
    line-height: 24px;
  }

  .figma-plugin__button {
    width: 100%;
  }
}
</style>
